/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFiltrosReferencias from './entidades/filtrosReferencias';
import IReferencias from './entidades/referencias';

export default class ModeloReferencias {
    public consultarReferencias() {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocioConfiguracion.get('Referencia/ConsultarListaReferencia'));
    }
    public crearReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocioConfiguracion.post('Referencia/GuardarReferencia', referencias));
    }
    public editarReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocioConfiguracion.put('Referencia/EditarReferencia', referencias));
    }
    public eliminarReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() =>
            negocioConfiguracion.delete('Referencia/EliminarReferencia', referencias)
        );
    }
    public consultarListaReferenciasPorFiltro(filtrosReferencias: IFiltrosReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(
            () => negocioConfiguracion.post('Referencia/ConsultarListaReferenciaPorFiltro', filtrosReferencias),
            true
        );
    }
}
